import React from 'react';
import PropTypes from 'prop-types';
import { buildThumbnailUrl } from '@bd/bdcore-utilities';
import withData from '@bd/bdcore-data';
import { get } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import PageHelmet from '@bd/bdcore-pagehelmet';


import Header from '../../components/Header';
import Footer from '../../components/Footer';
import InsideHeader from '../../components/InsideHeader';
import PageIntroBanner from '../../components/PageIntroBanner';
import TestimonialBanner from '../../components/TestimonialBanner';
import CtaBanner from '../../components/CtaBanner';
import MenuAbout from '../../components/MenuAbout';
import TeamModal from './teamModal';

const styles = css`
  .Team_wrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    padding: 0 0 50px;

      .Team_image {
        width: 200px;
        height: 275px;
        margin: 15px;
        position: relative;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        transition: all 0.5s ease-out;
        &:hover {
          .Team_overlay {
            opacity: 1;
            transition: all 0.5s ease-out;
          }
        }
      }

  }
  .Team_overlay {
    width: 100%;
    height: 100%;
    background-color: rgba(179, 206, 208, 0.9);
    color: $color1;
    position: absolute;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 17px;
    opacity: 0;
    transition: all 0.5s ease-out;

    .Overlay_wrapper {
      border: 2px solid #fff;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      h4 {
        font-weight: bold;
      }

      h4, h5 {
        width: 80%;
        text-align: center;
      }
    }
  }
`;

function Team({ page }) {
  if (!page) {
    return null;
  }

  return (
    <div className={styles}>
      <InsideHeader h1="The 70 West Team" background={get(page, 'page_image.contentUrl')} />
      <PageHelmet page={page} />
      <Header />
      <MenuAbout />
      <PageIntroBanner
        h2={get(page, 'intro_banner[0].top_headline')}
        h3={get(page, 'intro_banner[0].main_headline')}
        p={get(page, 'intro_banner[0].paragraph')}
        background={get(page, 'intro_banner[0].photo.contentUrl')}
      />
      <div className="full-width-headline-left">
        <div className="container">
          <h3>Meet the 70 West Team</h3>
        </div>
        <div className="lines" />
      </div>
      <div className="container px-5">
        <div className="row Team_wrapper">
          {
            page.team.map(item => (
              <TeamModal className="col-lg-3 team-card" key={item.name} team={item}>
                <div className="Team_image" style={{ backgroundImage: `url(${buildThumbnailUrl(item.photo.contentUrl, { width: 800, height: 800 })})` }}>
                  <div className="Team_overlay">
                    <div className="Overlay_wrapper">
                      <h4>{item.name}</h4>
                      <h5>{item.title}</h5>
                    </div>
                  </div>
                </div>
              </TeamModal>
            ))
          }
        </div>
      </div>

      <TestimonialBanner />
      <CtaBanner />
      <Footer />
    </div>
  );
}

Team.propTypes = {
  page: PropTypes.object,
};

Team.defaultProps = {
  page: undefined,
};

export default withData({
  page: 'meet_the_team',
})(Team);



// WEBPACK FOOTER //
// ./src/pages/Team/index.js